import React from 'react';

const ChangeProductButton = ({ onChangeProduct, onClearIndustrySelection }) => {
  const handleClick = () => {
    onChangeProduct();
    if (onClearIndustrySelection) {
      onClearIndustrySelection();
    }
  };

  return (
    <div className="col-8 mb-0">
      <div className="mb-1">
        <button
          className="btn btn-link p-0"
          onClick={handleClick}
          style={{
            fontSize: '12px',
            color: '#9CA3AF',
            textDecoration: 'none',
            border: 'none',
            background: 'transparent',
            fontWeight: '400'
          }}
          onMouseEnter={(e) => e.target.style.color = '#495057'}
          onMouseLeave={(e) => e.target.style.color = '#9CA3AF'}
        >
          <i className="bi bi-arrow-left me-1"></i>
          Cambiar producto
        </button>
      </div>
    </div>
  );
};

export default ChangeProductButton;
